module.exports = __webpack_public_path__ + "img/Stephanie-Small.5f58b8df.jpeg";